












































































































































import {
  defineComponent,
  computed,
  ref,
  useRoute
} from '~/utils/nuxt3-migration'
import CInfoModal from '~/components/shared/configurable/info/CInfoModal.vue'
import { ciTimes } from '~/icons/source/regular/times'
import { ciChevronLeft } from '~/icons/source/regular/chevron-left'

export default defineComponent({
  components: { CInfoModal },
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    info: {
      type: String,
      required: false,
      default: ''
    },
    contentClass: {
      type: [Object, String, Array],
      required: false,
      default: ''
    },
    headerClass: {
      type: [Object, String, Array],
      required: false,
      default: ''
    },
    actionClass: {
      type: [Object, String, Array],
      required: false,
      default: ''
    },
    minHeightClass: {
      type: [Object, String, Array],
      required: false,
      default: 'tw-min-h-0'
    },
    backTo: {
      type: [Object, String],
      default: null
    },
    smallTitle: {
      type: Boolean,
      default: false
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    nowrapHeader: {
      type: Boolean,
      default: false
    },
    overflowHidden: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  setup(props, { slots, emit }) {
    const hasTitle = computed(() => Boolean(slots.title || props.title))
    const hasSubtitle = computed(() =>
      Boolean(slots.subtitle || props.subtitle)
    )
    const hasInfo = computed(() => Boolean(slots.info || props.info))
    const hasHeader = computed(() => hasTitle.value || hasInfo.value)

    const isVisible = ref(true)

    const route = useRoute()

    const staticRightSection = computed(() => {
      return props.nowrapHeader && (hasSubtitle.value || hasInfo.value)
    })

    const handleDismissed = () => {
      emit('dismissed')
      isVisible.value = false
    }

    const inClassifiedView = computed(() => {
      return route.value.name?.startsWith('__classifieds_view')
    })

    return {
      hasTitle,
      hasSubtitle,
      hasInfo,
      hasHeader,
      isVisible,
      ciTimes,
      ciChevronLeft,
      handleDismissed,
      staticRightSection,
      inClassifiedView
    }
  }
})
